'use strict';

angular.module('youth').directive('msTrackerSummary', [function () {
  return {
    templateUrl: 'youth/templates/tracker-summary.html',
    restrict: 'A',
    scope: {
      trackerItems: '=msTrackerSummary',
      type: '@'
    }
  };
}]);